jQuery(document).ready(function($){

    $('.navbar-toggler').on('click', function() {
        $('#to-header-section').hide();
        $('.navbar-mobile').addClass('show');
    })

    $('.close-nav').on('click', function() {
        $('.navbar-mobile').removeClass('show');
        $('.navbar-desktop').show();
    })

    $(window).scroll(function () {
       
        var scrolled_val = $(document).scrollTop().valueOf();

        if (scrolled_val) {
            $('.header').addClass('sticky-menu')
        } else {
            $('.header').removeClass('sticky-menu')
        }
    });

    function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    $(window).on("scroll", function() {
        $(".animation-y-container, .animation-x-container, .animation-from-left, .animation-from-right").each(function () {
            let elementTop = $(this).offset().top;
            let elementHeight = $(this).outerHeight();
            let elementMid = elementTop + elementHeight / 2;
            let windowTop = $(window).scrollTop();
            let isMobileDevice = isMobile() || $(window).width() < 1200;
            let offset = isMobileDevice ? 0 : 100;
            let windowBottom = windowTop + $(window).height() - offset;
            let triggerPoint = isMobileDevice ? elementTop - 100 : elementMid;

            if (triggerPoint < windowBottom) {
                $(this).addClass("visible");
            }
        });
    });

    // Make external links open in new tab
    $('a[href^="http"]').each(function() {
        var link = $(this);
        var href = link.attr('href');
        var currentDomain = window.location.hostname;
        
        // Check if the link is external (doesn't contain current domain)
        if (href.indexOf(currentDomain) === -1) {
            link.attr('target', '_blank');
        }
    });
});